import axios from 'axios';

const axiosInstance = axios.create({
  baseURL:  process.env.REACT_APP_DATABASE_URL,
});

axiosInstance.interceptors.request.use(function (config) {
    const announcementKey = localStorage.getItem('announcement-key');
    config.headers['viewer-token']= announcementKey;
    return config;
  });

export default axiosInstance;
export const countVisitors = ( newEventId )=>{
    let EXPIRATION_DATE;
    if(localStorage.getItem("TODAY")){
        EXPIRATION_DATE = JSON.parse(localStorage.getItem("TODAY"))
    }else{
        EXPIRATION_DATE = {
            day:new Date().getDate()-1,
            month:new Date().getMonth(),
            year:new Date().getFullYear()
        }
    }
    const currentDate = new Date();// Current date 

    const dateChanges = EXPIRATION_DATE.day < currentDate.getDate()
    && EXPIRATION_DATE.month <= currentDate.getMonth()
    && EXPIRATION_DATE.year <= currentDate.getFullYear();


    // !REPLACE THIS IF STATEMENT IF YOU WANT A USER COUNT DAILY
    // if(newEventId && (dateChanges || newEventId != localStorage.getItem("EVENT_ID"))){

    // ! THIS IF STATEMENT IF YOU WANT A USER COUNT ONLY PER ANNOUNCE
    if(newEventId && ( newEventId != localStorage.getItem("EVENT_ID"))){
        // If today is after the expiry date
        // Send Incremental flag to the database;
        axiosInstance.post('/pages/increment-visitors', {'page_id' : newEventId})
        // Set the storage to meet today's date
        EXPIRATION_DATE.day = new Date().getDate()
        localStorage.setItem("EVENT_ID", newEventId)
        localStorage.setItem("TODAY", JSON.stringify(EXPIRATION_DATE));
    }else{
    }
}

